export default __webpack_public_path__ + "static/media/condense.102e6225.svg";